export const BASE_URL = "https://www.rimpac-shanghai.cn/"
export const INDEX_UR = "https://www.rimpac-shanghai.cn/index/dynamic/list"
export const CDN_BASE_URL = "https://cdn.rimpac-shanghai.cn/"
export const CDN_PDF = "https://cdn.rimpac-shanghai.cn"
export const CDN_BASE_IMG = "https://cdn.rimpac-shanghai.cn/pc"



//////////////////
// WEBPACK FOOTER
// ./common/config.js
// module id = KTao
// module chunks = 14